module.exports = {
  NODE_ENV: 'PRODUCTION',
  TEXT_LIMIT: 50,
  ROLE: {
    USER: 'USER',
    ADMIN: 'ADMIN',
    SUB_ADMIN: 'SUB_ADMIN',
  },
  ROUTE_ACCESS: {
    USER: 'USER',
    NEWS: 'NEWS',
    FAQ: 'FAQ',
    PAGE: 'PAGE',
    NFT: 'NFT',
    RESERVENFT: 'RESERVENFT',
    WALLET: 'WALLET',
    CART: 'CART',
    RELEASENFT: 'RELEASENFT',
    ADMIN_USERS: 'ADMIN_USERS',
    NFTCOPY: 'NFTCOPY',
    INVENTORY: 'INVENTORY',
    INVENTORYCATEGORY: 'INVENTORYCATEGORY',
    COLLECTION: 'COLLECTIONS',
    REWARDS: 'REWARDS',
    BADGES: 'BADGES',
    REDEEMCODE: 'REDEEMCODE',
    PROMOCODE: 'PROMOCODE',
    TRANSACTION: 'TRANSACTION',
    AUCTION: 'AUCTION',
    IMPORTNFT: 'IMPORTNFT',
    LOOKUP: 'LOOKUP',
    FEEDBACK: 'FEEDBACK',
    COUNTRIES: 'COUNTRIES',
    FANCAVEUPDATES: 'FANCAVEUPDATES',
    USERSNOTIFICATIONS: 'USERSNOTIFICATIONS',
    REFERRALCODES: 'REFERRALCODES',
    MINTAUTOMATICALLY: 'MINTAUTOMATICALLY',
    SHUFFLENFTS: 'SHUFFLENFTS',
    REPLACENFTS: 'REPLACENFTS',
    SYNCLOOKUPS: 'SYNCLOOKUPS',
    SENDCARDANO: 'SENDCARDANO',
    SYNCALGOLIA: 'SYNCALGOLIA',
    CREATEJSON: 'CREATEJSON',
    USERSLIST: 'USERSLIST',
    NEWSLIST: 'NEWSLIST',
    ISL: 'ISL',
    CAMPAIGNTRANSFER: 'CAMPAIGNTRANSFER'
  },
  VERSION: {
    PLATFORM: 'web',
    VERSION: '1.0',
    BUILD: '1.0',
  },
  ACCESS: {
    READ: "READ",
    WRITE: "WRITE",
  },
  NETWORK: {
    DEFAULT: 'network',
    NOT_FOUND: 404,
    ROUTE_NOT_FOUND: 'route_not_found',
    FAILED_REQUEST: 'request_failed',
  },
  MESSAGE: {
    ROLE: 'ROLE',
    REPLACE: 'REPLACE',
    MINTABLE: 'MINTABLE',
    TRANSACTION: 'TRANSACTION',
    URL: 'URL',
    TRANSFER: 'TRANSFER',
    RESERVE: 'RESERVE',
    SENT: 'SENT',
    RELEASE: 'RELEASE',
    ACCESS_CHANGE: "ACCESS_CHANGE",
    SHUFFLE: 'SHUFFLE',
    SHUFFLE_FAILED: 'SHUFFLE_FAILED',
    VIDEO: 'VIDEO',
    GIFTED: 'GIFTED',
    GIFT_FAILED: 'GIFT_FAILED',
    MINT: 'MINT',
    MINT_FAILED: 'MINT_FAILED',
    SENT_FAILED: 'SENT_FAILED',
    CREATE: 'CREATE',
    COMPLETE: 'COMPLETE',
    SYNC: 'SYNC',
    UPDATE: 'UPDATE',
    DELETE: 'DELETE',
    REFILL: 'REFILL',
    DOWNLOAD_START: 'DOWNLOAD_START',
    DOWNLOAD_FAILED: 'DOWNLOAD_FAILED',
    IMPORT: 'IMPORT',
    IMPORT_FAILED: 'IMPORT_FAILED',
    DOWNLOAD_DATA_NOT_FOUND: 'DOWNLOAD_DATA_NOT_FOUND',
    CLOSE: 'CLOSE',
    EMPTY: 'EMPTY',
    REQUIRE: 'REQUIRE',
    GREAT: 'GREAT',
    LESS: 'LESS',
    ADD: 'ADD',
    LIMIT_GREAT: 'LIMIT_GREAT',
    LIMIT_LESS: 'LIMIT_LESS',
    DECIMAL: 'DECIMAL',
    NUMERIC: 'NUMERIC',
    NOT_FOUND: 'NOT_FOUND',
    SELECT: 'SELECT',
    ALERT: 'ALERT',
    DISABLE: 'DISABLE',
    ENABLE: 'ENABLE',
    PAK: 'PAK',
    DLC: 'DLC',
    IMAGE: 'IMAGE',
    START_DATE_ERROR: 'START_DATE_ERROR',
    END_DATE_ERROR: 'END_DATE_ERROR'
  },
  NOTIFICATION: {
    TIMER: 20000,
  },
  AUCTION: {
    LIMIT: 10,
  },
  PAGES: {
    LIMIT: 10,
  },
  COUPON: {
    LIMIT: 10,
  },
  USERS: {
    LIMIT: 10,
  },
  ADMIN_USERS: {
    LIMIT: 10,
  },
  CATEGORIES: {
    LIMIT: 10,
  },
  TRANSACTION: {
    LIMIT: 10,
  },
  INVENTORY: {
    LIMIT: 10,
  },
  ITEM: {
    LIMIT: 10,
  },
  LOOKUP: {
    LIMIT: 10,
  },
  FAQS: {
    LIMIT: 10,
  },
  EDITION: {
    LIMIT: 10,
  },
  NEWS: {
    LIMIT: 10,
  },
  REDEEM: {
    LIMIT: 10,
  },
  TEAMS: {
    LIMIT: 10,
  },
  TV_KEYS: {
    LIMIT: 20,
  },
  COUNTRIES: {
    LIMIT: 10
  }
}
